/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import Pagination from 'components/common/pagination';
import Table from 'components/Form/Table';
import EmptyState from 'components/EmptyState';
import Fetching from 'components/Fetching';
import moment from 'moment';
import angleRight from 'assets/images/angle-right.png';
import SuccessModal from 'components/SuccessModal';
import SuccessGif from 'assets/animations/gifs/success.gif';
import { CloseIcon } from 'components/icons';
import { useHistory } from 'react-router';
import styles from '../terminal.module.scss';
import Button from '../../../components/button';
import { formatCurrency } from '../../../libs';
import RequestDetails from './modals/RequestDetails';
import Activate from './modals/Activate';
import CautionGif from '../../../assets/animations/gifs/caution.gif';

const TerminalRequestLog = (props) => {
  const { inProgress, page, handleRequestPagination, meta, data } = props;

  const [viewed, setViewed] = useState({});
  const history = useHistory();
  const [showRequest, setShowRequest] = useState(false);
  const [showActivate, setShowActivate] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleViewRequest = (item) => {
    setViewed(item);
    setShowRequest(true);
  };

  const handleRequestProceed = () => {
    setShowRequest(false);
    setShowActivate(true);
  };

  const handleOnRequestTerminal = () => {
    history.push('/terminal/order');
  };
  return (
    <>
      {inProgress ? (
        <div className={styles.terminalListEmpty}>
          <Fetching />
        </div>
      ) : data && data.length === 0 ? (
        <div className={styles.terminalListEmpty}>
          <EmptyState
            text="Click on the button below to request for a terminal"
            headerText="You have no request yet"
          />
          <Button
            onClick={() => handleOnRequestTerminal()}
            className={styles.requestBtnEmpty}
            text="Request Terminal"
            variant="primary"
            id="request-terminal-button"
          />
        </div>
      ) : (
        <>
          <div
            className={styles.terminalListContent}
            data-testid="terminal-log-table"
          >
            <div className={styles.terminalListContentBody}>
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>QUANTITY</Table.Th>
                    <Table.Th>AMOUNT</Table.Th>
                    <Table.Th>DATE REQUESTED</Table.Th>
                    <Table.Th>ACTIONS</Table.Th>
                    <Table.Th />
                  </Table.Tr>
                </Table.Thead>
                <Table.TBody>
                  {data &&
                    data.map((item, index) => (
                      <Table.Tr key={item.id + index}>
                        {/* <Table.Td>{`${item.name || '-'}`}</Table.Td> */}
                        <Table.Td>{`${item.quantity}`}</Table.Td>
                        <Table.Td>{formatCurrency(item.amount)}</Table.Td>
                        <Table.Td>
                          {item.createdAt &&
                            moment(item.createdAt).format(
                              'DD MMMM YYYY hh:mm A',
                            )}
                        </Table.Td>
                        <Table.Td>
                          <button
                            className={styles.viewAndActivate}
                            type="button"
                            onClick={() => handleViewRequest(item)}
                          >
                            View & Activate
                          </button>
                        </Table.Td>
                        <Table.Td>
                          <button
                            type="button"
                            onClick={() => handleViewRequest(item)}
                          >
                            <img
                              src={angleRight}
                              alt="angleRight"
                              data-testid="click-details-list"
                            />
                          </button>
                        </Table.Td>
                      </Table.Tr>
                    ))}
                </Table.TBody>
              </Table>
            </div>
          </div>
          <div className={styles.terminalPagination} data-testid="pagination">
            <p>
              Showing{' '}
              {meta.page === 0 ? data.length : data.length * (meta.page + 1)}{' '}
              items out of {Math.ceil(meta.total / meta.limit)}
              {Math.ceil(meta.total / meta.limit) > 1 ? ' pages' : ' page'}{' '}
              found
            </p>
            <div>
              <Pagination
                currentPage={page}
                handlePageClick={handleRequestPagination}
                totalItems={Math.ceil(meta.total / meta.limit)}
              />
            </div>
          </div>

          <RequestDetails
            drawerActive={showRequest}
            onClose={() => setShowRequest(false)}
            onProceed={handleRequestProceed}
            viewed={viewed}
          />

          <Activate
            drawerActive={showActivate}
            onClose={() => setShowActivate(false)}
            data={viewed}
            setShowActivate={setShowActivate}
            setSuccess={setSuccess}
            setError={setError}
          />

          {success && (
            <SuccessModal
              positiveBtn={() => {
                setSuccess(false);
                history.push('/terminal');
              }}
              negativeBtn={() => setSuccess(false)}
              decorationIcon={
                <img src={SuccessGif} alt="success" width="150" height="150" />
              }
              title="You’ve successfully activated your terminal."
              subtitle="You can start using it to collect payment and see your settlements immediately."
              buttonText="Dismiss"
              closeIcon={<CloseIcon />}
            />
          )}

          {error ? (
            <SuccessModal
              positiveBtn={() => setError(null)}
              decorationIcon={
                <img src={CautionGif} width="150" height="150" alt="" />
              }
              negativeBtn={() => setError(null)}
              title={error}
              buttonText="Dismiss"
              closeIcon={<CloseIcon />}
              showNegativeButton
              buttonStyle={styles.firstModalButton}
              titleStyle={styles.modalTitle}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default TerminalRequestLog;
